"use client";

type StatsItem = {
  value: string;
  label: string;
};

export default function StatsBanner({
  items = [
    { value: "180+", label: "Experts in our team" },
    { value: "23+", label: "Years of experience" },
    { value: "2500+", label: "Clients" },
    { value: "99%", label: "Customer Satisfaction" },
  ],
}: {
  items?: StatsItem[];
}) {
  return (
    <div className="w-full py-5 flex flex-wrap items-center justify-center gap-[30px]">
      {items?.map((it, idx) => (
        <div key={idx} className="flex items-center gap-[30px]">
          {idx !== 0 && (
            <span
              className="h-10 hidden xl:block w-px bg-white/10"
              aria-hidden
            />
          )}
          <div className="w-[205px] flex flex-col items-center gap-[10px]">
            <div className="text-white clash-font text-[30px] leading-[120%]">
              {it.value}
            </div>
            <div className="text-[#949596] text-[20px] leading-[160%] text-center">
              {it.label}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
